// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".facesheet-cases{position:relative}.facesheet-cases__header{display:flex;justify-content:flex-end;margin-bottom:20px}.facesheet-cases__pagination .pager .count>span{font-size:14px}@media only screen and (max-width: 540px){.facesheet-cases__header{display:block}.facesheet-cases__upload{width:100%}.facesheet-cases__form{width:100%}}", ""]);
// Exports
module.exports = exports;
